import Reveal from '@/components/feature/Reveal';
import PerformanceBoundary from '@/components/feature/PerformanceBoundary';
import MonthlyResults from './MonthlyResults';

export default function MonthlyBreakdown() {
  return (
    <section id="monthly" className="py-14 md:py-20 bg-background-50 scroll-mt-32 md:scroll-mt-36">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  Month-by-Month Account Results
                </h2>
                <p className="mt-2 text-sm text-foreground-600 max-w-xl">
                  Every month this live account has traded, grouped by year and taken straight from
                  the MetaTrader 5 statement. All figures are in{' '}
                  <strong className="font-semibold text-foreground-800">USC (US Cents)</strong>.
                </p>
              </div>
            </div>
          </Reveal>

          <PerformanceBoundary label="monthly results">
            {(data) => <MonthlyResults data={data} />}
          </PerformanceBoundary>
        </div>
      </div>
    </section>
  );
}